/**
 * Auto Field Fill
 * Automatically grabs field data, stores it, and fills it in on subsequent pages
 * 
 * Config Options
 * -- disableRadioAutoFill : Disables auto fill of radio box fields
 */
define('components/auto-field-fill',[
    'jquery',
    'logging',
    'storage',
    'application'
], function($, logging, storage, app) {
    'use strict';
    
    var _ModuleName = "Auto Field Fill";
    var _config = {
        storage: {
            prepend: "autofill-"
        },
        associations: [
            ['first', 'first_name', 'gifts-first'],
            ['last', 'last_name', 'gifts-last'],
            ['email', 'email_address', 'gifts-email', 'gifts-email-real'],
            ['address1', 'address', 'street_address'],
            ['postal_code', 'postal', 'zip', 'zip_code', 'gifts-zip'],
            ['phone_home', 'phone_number', 'phone']
        ],
        stored: false,
        options: {
            disableRadioAutoFill: false
        },
        useV2Process: false
    }

    var init = function(data) {
        if(data && data.disableRadioAutoFill) {
            logging.debug("Setting option to disable radio auto fill: " + data.disableRadioAutoFill, _ModuleName);
            _config.options.disableRadioAutoFill = data.disableRadioAutoFill;
        }

        if(app.getProcessVersionNumber() == '2.0') {
            logging.debug("Using Process Version 2.0");
            _config.useV2Process = true;
        }
    }

    var run = function() {
        logging.debug("Options Loaded", _ModuleName);
        console.log(_config.options);

        var $form = $('form');
        
        if($form.length) {
            // Make sure we only have one form
            $form = $form.length > 1 ? $($form[0]) : $form;
            logging.debug("Retrieving Form Data from storage and using to fill out fields", _ModuleName);
            _retrieveFormData($form);

            // Grab form data on button click
            $('.lp-pom-button').click(function() {
                _storeFormData($form, "Button Click");
            })
            // Grab on Form submit if button click didn't work
            $form.submit(function(){
                _storeFormData($form, "Form Submit");
                return true;
            });
            // Backup method, grab on page unload
            $(window).on("beforeunload", function() {
                _storeFormData($form, "Page Navigation");
            })
        } else {
            logging.error("Could not find the form on the page.", _ModuleName);
        }
    }

    var _storeFormData = function($form, methodName) {
        if(!_config.stored) {
            logging.debug("Storing form data on " + methodName, _ModuleName);
            _saveFormData($form);
            _config.stored = true;
        }
    }

    var _saveFormData = function($form) {
        if($form.length) {
            // save text fields
            $("input[type='text'], input[type='email'], input[type='tel']", $form).each(function(i, obj) {
                var fieldValue = obj.value;
                var fieldID = obj.getAttribute("id");
                storage.setLocalStorage(_config.storage.prepend + fieldID, fieldValue);
            });

            // save select fields
            $(".lp-pom-form select").each(function(i, obj) {
                var fieldValue = obj.value;
                var fieldID = obj.getAttribute("id");
                storage.setLocalStorage(_config.storage.prepend + fieldID, fieldValue);
            });

            // save checkbox fields
            $("input[type='checkbox']", $form).each(function(i, obj) {
                var fieldValue = obj.checked;
                var fieldID = obj.getAttribute("id");
                storage.setLocalStorage(_config.storage.prepend + fieldID, fieldValue);
            });

            if(!_config.options.disableRadioAutoFill) {
                // save radio fields
                $("input[type='radio']:checked", $form).each(function(i, obj) {
                    var fieldValue = "true";
                    var fieldID = obj.getAttribute("id");
                    storage.setLocalStorage(_config.storage.prepend + fieldID, fieldValue);
                });

                $("input[type='radio']:not(:checked)", $form).each(function(i, obj) {
                    var fieldValue = "false";
                    var fieldID = obj.getAttribute("id");
                    storage.setLocalStorage(_config.storage.prepend + fieldID, fieldValue);
                });
            }
        } else {
            logging.error("Failed to find form element. Unable to Save form data", _ModuleName);
        }
    }
    
    var  _retrieveFormData = function($form) {
        if($form.length) {
            // look for and populate text fields
            $("input[type='text'], input[type='email'], input[type='tel']", $form).each(function(i, obj) {
                var fieldID = obj.getAttribute("id");
                var fieldNames = _getAssociatedFieldNames(fieldID);

                // if using the V2 process, we'll first check in app data for field data
                var foundInAppData = false;
                if (_config.useV2Process) {
                    logging.debug("Using V2 Process, so we're getting any lead data from the app and checking the fields.", _ModuleName);
                    var lead = app.getLeadData();
                    if (lead) {
                        for(var f = 0; f < fieldNames.length; f++) {                   
                            if (fieldNames[f] == "first" && lead.firstName) {
                                logging.debug("Populating First Name from App Data", _ModuleName);
                                obj.value = lead.firstName;
                                foundInAppData = true;
                            } else if (fieldNames[f] == "last" && lead.lastName) {
                                logging.debug("Populating Last Name from App Data", _ModuleName);
                                obj.value = lead.lastName;
                                foundInAppData = true;
                            } else if (fieldNames[f] == "email" && lead.email) {
                                logging.debug("Populating Email from App Data", _ModuleName);
                                obj.value = lead.email;
                                foundInAppData = true;
                            }
                        }
                    } else {
                        logging.debug("No lead data found from App, unable to populate fields.", _ModuleName);
                    }
                }

                // if not found, then we'll check local storage
                if (!foundInAppData) {
                    for(var f = 0; f < fieldNames.length; f++) {
                        var fieldSavedValue = storage.getLocalStorage(_config.storage.prepend + fieldNames[f]);
                        if(fieldSavedValue != undefined && fieldSavedValue != "" && fieldSavedValue != null) {
                            logging.debug("Setting Field ID " + fieldNames[f] + " to " + fieldSavedValue, _ModuleName);
                            obj.value = fieldSavedValue;
                            break;
                        }
                    }
                }
            });

            // look for and populate select fields
            $("select", $form).each(function(i, obj) {
                var fieldID = obj.getAttribute("id");
                var fieldNames = _getAssociatedFieldNames(fieldID);
                for(var f = 0; f < fieldNames.length; f++) {
                    var fieldSavedValue = storage.getLocalStorage(_config.storage.prepend + fieldNames[f]);
                    if(fieldSavedValue != undefined && fieldSavedValue != "" && fieldSavedValue != null) {
                        if (fieldSavedValue.indexOf("'") > -1) { continue; }
                        logging.debug("Setting Field ID " + fieldNames[f] + " to " + fieldSavedValue, _ModuleName);
                        $(".lp-pom-form #" + fieldID + " option[value='" + fieldSavedValue + "']").attr('selected', true);
                        break;
                    }
                }
            });

            // look for and populate checkbox fields
            $("input[type='checkbox']", $form).each(function(i, obj) {
                var fieldID = obj.getAttribute("id");
                var fieldNames = _getAssociatedFieldNames(fieldID);
                for(var f = 0; f < fieldNames.length; f++) {
                    var fieldSavedValue = storage.getLocalStorage(_config.storage.prepend + fieldNames[f]);
                    if(fieldSavedValue != undefined && fieldSavedValue != "" && fieldSavedValue != null && fieldSavedValue != "false") {
                        logging.debug("Setting Field ID " + fieldNames[f] + " to Checked", _ModuleName);
                        obj.checked = fieldSavedValue;
                        break;
                    }
                }
            });

            if(!_config.options.disableRadioAutoFill) {
                // look for and populate radio button fields
                $("input[type='radio']", $form).each(function(i, obj) {
                    // fieldValue = obj.value;
                    var fieldID = obj.getAttribute("id");
                    var fieldNames = _getAssociatedFieldNames(fieldID);
                    for(var f = 0; f < fieldNames.length; f++) {
                        var fieldSavedValue = storage.getLocalStorage(_config.storage.prepend + fieldNames[f]);
                        if(fieldSavedValue == true || fieldSavedValue == "true") {
                            logging.debug("Setting Field ID " + fieldNames[f] + " to Selected", _ModuleName);
                            $("#"+fieldID).prop('checked',true);
                            break;
                        }
                    }
                });
            }
        } else {
            logging.error("Unable to find form element. Failed to auto-fill fields", _ModuleName);
        }
    }

    /**
     * Gets a list of all field names that should be checked (including the given name) for the name given
     * @param {Array} associations 
     */
    var _getAssociatedFieldNames = function(name) {
        for(var i = 0; i < _config.associations.length; i++) {
            if(_config.associations[i].includes(name)) {
                return _config.associations[i];
            }
        }

        return [ name ];
    }

    return {
        init: init,
        run: run
    }
});
